import { Component, Input, OnDestroy, OnInit, inject } from '@angular/core';

import { ToastComponent } from '../../toast/toast.component';
import { ClientService } from '../../../services/client.service';
import { Client } from '../../models/client.model';
import { contracts, dateRegexp, ee, urlRegexp, usernameRegexp } from '../../constants';
import { capitalizeFirstChar, setClassInvalidTpl } from '../../functions';
import { ClientContract, ClientGoal } from '../../types';
import { finalize } from 'rxjs/operators';

@Component({
  selector: 'app-edit-client-details-modal',
  templateUrl: './edit-client-details-modal.component.html',
  standalone: false
})
export class EditClientDetailsModalComponent implements OnInit, OnDestroy {
  toast = inject(ToastComponent);
  private clientService = inject(ClientService);


  @Input() client: Client = {};
  @Input() field = '';
  @Input() reviewYear = '';

  contract: ClientContract = {
    id: 0,
    name: '',
    startDate: '', endDate: '',
    money: 0,
    cancellationDate: '', cancellationDays: 0,
    autorenewal: false
  };
  goal: ClientGoal = { id: 0, description: '', dueDate: '', achieved: false };
  reviews: any = {};

  contracts = contracts;
  usernameRegexp = usernameRegexp;
  dateRegexp = dateRegexp;
  urlRegexp = urlRegexp;
  setClassInvalidTpl = setClassInvalidTpl;

  ngOnInit(): void {
    // This is executed N+1 times, to fix eventually
    ee.on('showEditClientDetailsModal', (field: string, item?: ClientContract | ClientGoal | any) => this.editClient(field, item));
  }

  ngOnDestroy(): void {
    ee.off('showEditClientDetailsModal', () => {});
  }

  editClient(field: string, item?: ClientContract | ClientGoal | any) {
    this.field = field;
    if (this.field === 'contract') {
      this.contract = item;
      this.contract.startDate = (this.contract.startDate as string)?.substring(0, 10);
      this.contract.endDate = (this.contract.endDate as string)?.substring(0, 10);
      this.contract.cancellationDate = (this.contract.cancellationDate as string)?.substring(0, 10);
      this.contract.cancellationDays = this.contract.cancellationDays || 0;
    }
    if (this.field === 'goal') {
      this.goal = item;
      this.goal.dueDate = (this.goal.dueDate as string).substring(0, 10);
    }
  }

  updateClientService(client: Client): void {
    this.clientService.update(client)
      .pipe(finalize(() => ee.emit('getClient')))
      .subscribe({
        next: res => this.toast.setMessage('Client updated successfully', 'success'),
        error: err => this.toast.setMessage(err.error.message, 'danger'),
      });
  }

  updateClient(field: string): void {
    const client: Client = {
      _id: this.client._id,
      [field]: this.client[field]
    };
    this.updateClientService(client);
  }

  updateArrayField(field: 'contract' | 'goal'): void {
    const client: Client = {
      _id: this.client._id
    };
    const criteria = {
      contract: this.contract,
      goal: this.goal
    };
    this.clientService.updateArrayField(client, criteria[field], field)
      .pipe(finalize(() => ee.emit('getClient')))
      .subscribe({
        next: res => this.toast.setMessage(`${capitalizeFirstChar(field)} updated successfully`, 'success'),
        error: err => this.toast.setMessage(err.error.message, 'danger'),
      });
  }

}
